import React from "react";
import { Col, Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import MonthlyDonorsChart from "./MonthlyDonorsChart";

// Static data for monthly donors
const STATIC_MONTHLY_DATA = {
  months: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  registered: [120, 145, 132, 168, 195, 210, 185, 220, 198, 245, 230, 275],
  visited: [95, 118, 105, 140, 165, 178, 155, 190, 170, 210, 195, 240],
};

const MonthlyDonorsWrapper = () => {
  const { t } = useTranslation();

  return (
    <Col xl={12} lg={12}>
      <Card>
        <Card.Header>
          <Card.Title>{t("Monthly Donors (Registered/Visited)")}</Card.Title>
        </Card.Header>
        <Card.Body>
          <MonthlyDonorsChart data={STATIC_MONTHLY_DATA} />
        </Card.Body>
      </Card>
    </Col>
  );
};

export default MonthlyDonorsWrapper;
